// Constants and utilities for Expense forms

export const CATEGORIES = [
  'Auditor Expenses',
  'Dozer',
  'Electricity',
  'Employee Celebration',
  'Employee Expenses',
  'Equipment',
  'Food',
  'Fuel',
  'Gasifier Wood/Transport',
  'Infra Development',
  'Local Support',
  'Maintenance',
  'Marketing',
  'Material',
  'MESH',
  'Not Sure',
  'Rent',
  'Silica Purchase',
  'Software',
  'Transport Advance',
  'Transport From Mine to Plant',
  'Other'
];

export const EMPLOYEE_SUB_CATEGORIES = [
  'Salary',
  'Recharge',
  'Ration',
  'Salary Advance',
  'Advance Deducted',
  'Other'
];

export const PAYMENT_METHODS = ['Cash', 'Credit Card', 'Debit Card', 'Bank Transfer', 'UPI', 'Check', 'Cash + Bank Transfer'];
export const STATUSES = ['pending', 'approved', 'rejected'];

// Prevent scroll wheel from changing number input values
export const preventWheelChange = (e) => {
  e.target.blur();
};

// Field configurations for each category
export const getCategoryConfig = (category, subCategory) => {
  const baseConfig = {
    vendorField: 'Vendor Name',
    vendorPlaceholder: 'Enter vendor name',
    vendorEditable: true,
    showSubCategory: false,
    showEmployeeSelect: false,
    showMultiEmployeeSelect: false,
    showTransportFields: false,
    showReason: false,
    showInfraFields: false,
    billRequired: true
  };

  switch (category) {
    case 'Fuel':
      return { ...baseConfig, vendorField: 'Gas Station', vendorPlaceholder: 'Enter gas station name' };
    case 'Silica Purchase':
      return { 
        ...baseConfig, 
        vendorField: 'Vendor Name', 
        vendorPlaceholder: 'Silica Syndicate', 
        vendorEditable: false, 
        defaultVendor: 'Silica Syndicate',
        showSilicaFields: true,
        showGstBillField: true,
        billRequired: false
      };
    case 'Electricity':
      return { ...baseConfig, vendorField: 'Vendor Name', vendorPlaceholder: 'Andhra Pradesh State Electricity Board', vendorEditable: false, defaultVendor: 'Andhra Pradesh State Electricity Board' };
    case 'Rent':
      return { ...baseConfig, vendorField: 'Owner Name', vendorPlaceholder: 'Enter owner name' };
    case 'Employee Expenses':
      const isRation = subCategory === 'Ration';
      return { 
        ...baseConfig, 
        showSubCategory: true, 
        showEmployeeSelect: !isRation,
        showMultiEmployeeSelect: isRation,
        vendorField: 'Employee Name',
        vendorPlaceholder: 'Select employee',
        billRequired: false
      };
    case 'Local Support':
      return { ...baseConfig, vendorField: 'Person Name', vendorPlaceholder: 'Enter person name', billRequired: false, showReason: true };
    case 'Auditor Expenses':
      return { ...baseConfig, vendorField: 'Auditor Name', vendorPlaceholder: 'Enter auditor name', showReason: true };
    case 'Transport From Mine to Plant':
      return { ...baseConfig, showTransportFields: true, showGstBillField: true };
    case 'Transport Advance':
      return { ...baseConfig, showTransportFields: false };
    case 'Maintenance':
    case 'Equipment':
    case 'Software':
    case 'Other':
      return { ...baseConfig, vendorField: 'Vendor Name', vendorPlaceholder: 'Enter vendor name' };
    case 'Food':
      return { ...baseConfig, vendorField: 'Vendor/Restaurant Name', vendorPlaceholder: 'Enter vendor/restaurant name' };
    case 'Marketing':
      return { ...baseConfig, vendorField: 'Marketing Medium', vendorPlaceholder: 'Enter marketing medium' };
    case 'Infra Development':
      return { ...baseConfig, showInfraFields: true, vendorField: null };
    default:
      return baseConfig;
  }
};
